import "./KeduLoading.css";

export default function KeduLoading({ props }) {
  return (
    <div className="loader-wrapper text-center flex align-items-center justify-content-center">
      <div className="loader"></div>
    </div>
  );
}